<template>
  <div class="customer-odontogram mt-4">
    <b-tabs justified lazy>
      <b-tab key="elastics" title="Elásticos / Arcos">
        <customer-ortho-elastics :customer="customer"></customer-ortho-elastics>
      </b-tab>
      <b-tab key="iprs" title="IPRs">
        <customer-ortho-iprs :customer="customer"></customer-ortho-iprs>
      </b-tab>
      <b-tab key="implants" title="Implantes">
        <customer-odonto-implants :customer="customer"></customer-odonto-implants>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  props: ['customer']
}
</script>
